import React from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { JOIN_TYPE, MEMBER_TYPE_STRING_CAPITAL } from "src/modules/const"
import { Box, Grid } from "src/UILibrary"
import { ApplicationStatusLabel } from "./ApplicationStatusLabel"

type Props = {
  item: any
  handleSelected: any
}

export const ApplicationTableItem = ({ item, handleSelected }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.inbox" })

  const isPC = useMediaQuery({ query: "(min-width: 1400px)" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })

  const getMethodString = () => {
    switch (item.application.type) {
      case JOIN_TYPE.ONLINE:
        return t("online")
      case JOIN_TYPE.OFFLINE:
        return t("offline")
    }
    return ""
  }

  return (
    <Box
      sx={{
        ":hover": { opacity: 0.8, cursor: "pointer" },
      }}
      onClick={() => handleSelected(item)}
    >
      {isTablet ? (
        <Grid
          container
          sx={{
            mt: "0px",
            height: "32px",
            borderBottom: "1px dotted #D4D3D7",
            minHeight: "80px",
          }}
        >
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 1}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            {item.application.createdAt?.slice(0, 16).replace("T", " ")}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 1}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            <ApplicationStatusLabel
              isBehalf={item.application.userType === MEMBER_TYPE_STRING_CAPITAL.ADMINISTRATOR}
              status={item.application.status as string}
            />
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 2 : isTablet ? 2 : 1}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            {`${item.user?.lastName} ${item.user?.firstName}`}
          </Grid>
          <Grid
            item
            className="notosans weight500"
            color="text.primary"
            md={isPC ? 6 : isTablet ? 2 : 1}
            sm={12}
            xs={12}
            fontSize={14}
            sx={{ my: "auto", px: "20px" }}
          >
            {getMethodString()}
          </Grid>
        </Grid>
      ) : (
        <Box display="display" sx={{ borderBottom: "1px dotted #D4D3D7" }}>
          <Box display="flex">
            <Box
              className="notosans weight500"
              color="text.primary"
              width={150}
              fontSize={14}
              sx={{ mt: "10px", ml: "10px" }}
            >
              {item.application.createdAt?.slice(0, 16).replace("T", " ")}
            </Box>
            <Box
              className="notosans weight500"
              color="text.primary"
              fontSize={14}
              sx={{ mt: "10px", ml: "10px" }}
            >
              <ApplicationStatusLabel
                isBehalf={item.application.userType === MEMBER_TYPE_STRING_CAPITAL.ADMINISTRATOR}
                status={item.application.status as string}
              />
            </Box>
          </Box>
          <Box>
            <Box sx={{ mt: "0px", ml: "10px", width: "100%" }}>
              {`${item.user?.lastName} ${item.user?.firstName}`}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}
